import { render, staticRenderFns } from "./public-list-comp-body.vue?vue&type=template&id=16847608&"
import script from "./public-list-comp-body.vue?vue&type=script&lang=ts&"
export * from "./public-list-comp-body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports